import { GetUsageReportFilter, UsageReport2Filter, UsageReport, UsageReport2 } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { singleSortQueryFromPaginatedRequestParams, UsageRequestParams } from '../nm-types'
import { jsonParse, jsonStringify } from 'common/serialization'

export class UsageApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  readUsage({ startDate, endDate, type, format, ...params }: UsageRequestParams): Promise<UsageReport> {
    const filter: GetUsageReportFilter = {
      startDate,
      endDate,
      type,
      format,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    return this.edgeClient.getUsageReport(query)
  }
  async readUsage2({
    startDate,
    endDate,
    format,
    serviceType: serviceTypeString,
    groupId,
    ...params
  }: UsageRequestParams): Promise<UsageReport2> {
    const serviceType = serviceTypeString as UsageReport2Filter['serviceType'] | undefined
    const filter: UsageReport2Filter = {
      startDate,
      endDate,
      serviceType,
      groupId,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    const result = await this.edgeClient.getUsage(query)
    // Convert bigint strings (e.g. "bigint(123)") back to actual BigInt values
    return jsonParse(jsonStringify(result))
  }
}
